import NODE_ENV from '@constants/NodeEnv';

export default function isProd(): boolean {
  return NODE_ENV === 'prod' || NODE_ENV === 'production';
}

export function isDev(): boolean {
  return NODE_ENV === 'dev' || NODE_ENV === 'development';
}

export function isStaging(): boolean {
  return NODE_ENV === 'staging';
}

/** Shipped staging/prod bundles (not local dev server with `/api` proxy). */
export function isDeployed(): boolean {
  return isProd() || isStaging();
}
